var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._b({staticClass:"app-card__item",class:_vm.data.staticClass},'div',_vm.data.attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }